angular.module("dx.webapp.api", [
	"digiexam.exam",
	"dx.webapp.clientVersion",
	"dx.webapp.saml",
]);
